import { render, staticRenderFns } from "./ans.vue?vue&type=template&id=31078884&scoped=true&"
import script from "./ans.vue?vue&type=script&lang=js&"
export * from "./ans.vue?vue&type=script&lang=js&"
import style0 from "./ans.vue?vue&type=style&index=0&id=31078884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31078884",
  null
  
)

export default component.exports